import View from './Logo.view';

export default View;
